import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth'
//import axiosget from 'axios'
//import globalAxios from 'axios'

import routes from './routes/routes.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken: null,
    user: null,
    virusdata:null,
    countrydata:null,
    entomologicaldata:null,
    name:null,
  },
  mutations: {
    storeUser (state, user) {
      state.user = user
    },
    pagename (state, name){
      state.name = name
    }

  },
  actions: {
    pageName ({commit}, name) {
      //console.log(name)
      
      commit('pagename', name.name)
      //this.$store.state.user=authData.username
    },

   async login ({commit, dispatch}, authData) {

    await  axios.post('/api-token/', {
        username: authData.username,
        password: authData.password,
      })
        .then(res => {
          localStorage.setItem('token', res.data.access)
          
          
          if(res.data.access !== null){ routes.replace('/dashboard')}
          commit('storeUser', authData.username)
        })
        .catch(error => console.log(error))
      //console.log(authData)
     
    },

    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      //localStorage.removeItem('page_name')
      routes.replace('/')
      location.reload();
    },
    async fetchUser ({commit}) {

      const token = localStorage.getItem('token')
      
      const username = localStorage.getItem('username')
      //console.log("username",username)
     await axios.get('/user/', { 
       headers: { Authorization: `Bearer ${token}` } ,
       params: {username: username}
      })//username
        .then(response => {
          console.log(response.data)
          localStorage.setItem("user", JSON.stringify(response.data[0]));
          commit('storeUser', response.data)
          // this.$store.state.APIData = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },


    },
  getters: {
    PageName (state) {
      return state.name
    },
    user (state) {
      return state.user
    },
    
    isAuthenticated (state) {
      return state.idToken !== null
    }
  }
})
